// extracted by mini-css-extract-plugin
module.exports = {"loader":"PageOverlayLoader_loader__3hwwi","loaderOuter":"PageOverlayLoader_loaderOuter__1fh95"};